import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import uniqid from 'uniqid'

import { setAlternatives, deleteAlternatives } from 'redux/smartchat/alternatives/actions'
import AlternativesUI from './AlternativesUI'

const Alternatives = ({ isRequired, label, value, fromAlternativesId, error }) => {
  const dispatch = useDispatch()
  const [isOpenAlternativesModal, setIsOpenAlternativesModal] = useState(false)
  const [alternativesId, setAlternativesId] = useState('')

  const toggleAlternativesModal = () => {
    if (!isOpenAlternativesModal) {
      const alternativesId = uniqid('alternatives-')
      setAlternativesId(alternativesId)
      if (value) {
        dispatch(setAlternatives({ alternativesId, alternativesData: value }))
      } else {
        dispatch(setAlternatives({ alternativesId }))
      }
    } else {
      dispatch(deleteAlternatives({ alternativesId }))
      setAlternativesId('')
    }

    setIsOpenAlternativesModal(!isOpenAlternativesModal)
  }

  return (
    <AlternativesUI
      isRequired={isRequired}
      label={label}
      alternativesId={alternativesId}
      fromAlternativesId={fromAlternativesId}
      value={value}
      isOpenAlternativesModal={isOpenAlternativesModal}
      toggleAlternativesModal={toggleAlternativesModal}
      error={error}
    />
  )
}

export default Alternatives
